<template>
    <div>
        <v-data-table
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="total"
                :loading="isFetch"
                loading-text="Загрузка данных... Ожидайте"
                :footer-props="{
                  itemsPerPageOptions: [5, 10, 15, 50]
                }"
        >
            <template v-slot:item.actions="{ item }">
                <v-btn
                        v-if="item.state === 'PARTICIPANT' && (USER_ID === item.id || canRemove)"
                        class="mx-2"
                        :fab="USER_ID !== item.id"
                        dark
                        small
                        color="error"
                        depressed
                        @click="onRemoveConfirm(item.id)"
                >
                    <v-icon
                      v-if="USER_ID !== item.id"
                      small
                    >
                        mdi-delete
                    </v-icon>
                    <span v-else>Покинуть</span>
                </v-btn>
                <v-btn
                    v-if="canRemove && item.state === 'INVITED' && item.appends.status_raw === 'ACTIVE'"
                    :disabled="isFetch"
                    depressed
                    color="error"
                    class="mx-2"
                    dark
                    small
                    @click="onCloseInvite(item.id)"
                >
                    закрыть
                </v-btn>
            </template>
        </v-data-table>
        <dialog-confirm ref="dialogConfirm"
                        max-width="800px"
                        :title="dialogConfirm.title"
                        :text="dialogConfirm.text"
                        @close="onCloseDialogConfirm"
                        @confirm="onRemove(dialogConfirm.rmId)"
        ></dialog-confirm>
    </div>
</template>

<script>
import * as api from '@/api/workspace';
import {mapActions, mapGetters} from 'vuex';
import DialogConfirm from "../DialogConfirm.vue";
export default {
    components: {DialogConfirm},
    name: "WorkSpaceParticipants",
    props:{
        workSpaceId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isFetch: false,
            options: {
                perPage: 10,
                page: 1
            },
            total: 0,
            itemsData: [],
            dialogConfirm: {
                title: '',
                text: '',
                rmId: null
            }
        }
    },
    watch: {
        options: {
            handler () {
                this.load();
            },
            deep: true,
        },
        workSpaceId: function () {
            this.options.page = 1;
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        ...mapActions('workspace', ['LEAVE']),
        async onCloseInvite(inviteId){
            this.isFetch = true;
            try{
                let { data } = await api.inviteClose(this.workSpaceId, inviteId);
                this.SHOW_SUCCESS(data.message);
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка закрытия'});
                console.log(e);
            }finally {
                this.isFetch = false;
                this.load();
            }
        },
        async load(){
            this.isFetch = true;
            const { page, itemsPerPage } = this.options
            try{
                let { data } = await api.users(this.workSpaceId, {page, perPage: itemsPerPage});
                this.total = data.meta.total
                this.itemsData.splice(0, this.itemsData.length, ...data.data);
            }catch (e) {
                this.SHOW_ERROR('Ошибка загрузки данных');
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        },
        onCloseDialogConfirm(){
            this.dialogConfirm.title = '';
            this.dialogConfirm.text = '';
            this.dialogConfirm.rmId = null;
        },
        async onRemoveConfirm(id){
            if(id === this.USER_ID){
                this.dialogConfirm.title = 'Вы точно хотите покинуть данное пространство?';
                this.dialogConfirm.text = `При подтверждении действия доступ к пространству "${this.NAME_WORK_SPACE}" будет для Вас закрыт.<br/>` +
                    'Повторно зайти в данное пространство можно будет только по приглашению владельца пространства.';
            }else{
                this.dialogConfirm.title = 'Вы точно хотите отключить участника?<br/>';
                this.dialogConfirm.text = 'При отключении участник больше не сможет заходить в Ваше пространство "#737 мое пространство".<br/>' +
                    'Чтобы он смог заново зайти, придется повторно его пригласить.';

            }
            this.dialogConfirm.rmId = id;
            this.$refs.dialogConfirm.show();
        },
        async onRemove(id){
            try{
                let data = await this.LEAVE(id);
                this.SHOW_SUCCESS(data.message);
                this.$emit('remove', {user_id: id});
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка удаления пользователя'});
                console.log(e);
            }
            finally {
                if(this.USER_ID !== id){
                    this.load();
                }
            }
        }
    },
    computed:{
        ...mapGetters('user', ['USER_ID', 'IS_ADMIN']),
        ...mapGetters('workspace', ['NAME_WORK_SPACE', 'IS_OWNER']),
        headers(){
            return [
                { text: 'Имя', value: 'name' },
                { text: 'Статус', value: 'state_slug' },
                { text: 'email', value: 'email' },
                { text: 'Телефон', value: 'phone' },
                { text: 'Действия', value: 'actions' }
            ];
        },
        items(){
            return this.itemsData;
        },
        canRemove(){
            return this.IS_OWNER || this.IS_ADMIN;
        }
    }
}
</script>

<style scoped>

</style>